import { LandingResolver } from './features/landing/landing.resolver';
import { CandidateStatementComponent } from './features/candidate-statement/candidate-statement.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { LandingComponent } from './features/landing/landing.component';
import { SettingsComponent } from './features/settings/settings.component';
import { SuccessPageComponent } from './features/success-page/success-page.component';
import { BallotreviewComponent } from './features/ballotreview/ballotreview.component';
import { VotingpageComponent } from './features/votingpage/votingpage.component';
import { HelpComponent } from './features/help/help.component';
import { AuthGuardService as AuthGuard } from './service/auth-guard.service';
import { RecoveryComponent } from './features/recovery/recovery.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: { title: 'Login' }
  },
  {
    path: 'landing',
    component: LandingComponent,
    data: { title: 'Landing Page' },
    canActivate: [AuthGuard],
    resolve: { InitialData: LandingResolver }
  },
  {
    path: 'voting',
    component: VotingpageComponent,
    data: { title: 'Voting Page' },
    canActivate: [AuthGuard],
  },
  {
    path: 'ballot-review',
    component: BallotreviewComponent,
    data: { title: 'Ballot Review' },
    canActivate: [AuthGuard],
  },
  {
    path: 'candidate-statement/:id',
    component: CandidateStatementComponent,
    data: { title: 'Candidate Page' },
    canActivate: [AuthGuard],
  },
  {
    path: 'recovery',
    component: RecoveryComponent,
    data: { title: 'PIN Recovery' }
  },
  {
    path: 'settings',
    component: SettingsComponent
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },
  {
    path: 'success',
    component: SuccessPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [LandingResolver]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts